import React, {useEffect } from 'react';
//import Main from "../content/MainHolding";
import Main from "../content/Main";
import SoftwareDevelopment from "../content/Services/SoftwareDevelopment";
import RoboticsAutomation from '../content/Services/RoboticsAutomation';
import AIMachineLearning from '../content/Services/AIMachineLearning';
import ControlSystemIntegration from '../content/Services/ControlSystemIntegration';
import DatabaseLIMS from '../content/Services/DatabaseLIMS';
import IOT from '../content/Services/IOT';
import MaintenanceSupport from '../content/Services/MaintenanceSupport';
import Training from '../content/Services/Training';
import MachineVision from '../content/Services/MachineVision';
import ContactForm from '../content/ContactForm';
import OurServices from '../content/OurServices';
import About from '../content/About';
import NotFound from "../content/NotFound";
import { BrowserRouter as Router, Route, Routes,Navigate } from "react-router-dom";
import ReactGA from 'react-ga4';
import ScrollToTop from './ScrollToTop';
const TRACKING_ID = "G-PDFHZSY9Z6"; // OUR_TRACKING_ID

ReactGA.initialize(TRACKING_ID);


const MyRoutes = () => {

  useEffect(() => {
    ReactGA.send("pageview");//.(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Main />} />
          {/* <Route exact path="/SoftwareDevelopment" element={<SoftwareDevelopment />} /> */}
          {/* <Route exact path="/RoboticsAutomation" element={<RoboticsAutomation />} /> */}
          <Route
            path="/SoftwareDevelopment"
            element={<Navigate to="/Services/SoftwareDevelopment" replace />}
          />
          <Route
            path="/RoboticsAutomation"
            element={<Navigate to="/Services/RoboticsAutomation" replace />}
          />

          <Route exact path="/OurServices" element={<OurServices />} />
          <Route exact path="/Services" element={<OurServices />} />
          <Route exact path="/Contact" element={<ContactForm />} />
          <Route exact path="/About" element={<About />} />

          <Route exact path="/Services/SoftwareDevelopment" element={<SoftwareDevelopment/>} />
          <Route exact path="/Services/RoboticsAutomation" element={<RoboticsAutomation/>} />
          <Route exact path="/Services/AIMachineLearning" element={<AIMachineLearning/>} />
          <Route exact path="/Services/ControlSystemIntegration" element={<ControlSystemIntegration/>} />
          <Route exact path="/Services/DatabaseLIMS" element={<DatabaseLIMS/>} />
          <Route exact path="/Services/IOT" element={<IOT/>} />
          <Route exact path="/Services/MaintenanceSupport" element={<MaintenanceSupport/>} />
          <Route exact path="/Services/Training" element={<Training/>} />
          <Route exact path="/Services/MachineVision" element={<MachineVision/>} />


          <Route path='*' element={<NotFound />} status={404} />
        </Routes>
      </Router>
    </>
  );
};

export default MyRoutes;
